@let filteredDataForAutocomplete = filteredDataForAutocomplete$ | async;
<div class="quick-search-container" [ngClass]="{ mobile: mobile }">
  <form [formGroup]="quickSearchForm" class="quick-search-form">
    <mat-form-field
      appearance="outline"
      [ngClass]="{ mobile: mobile }"
      class="filter-form-container-field"
      >
      <input
        #matInputField
        type="text"
        [placeholder]="'QUICK_SEARCH' | translate"
        matInput
        formControlName="searchControl"
        [matAutocomplete]="auto"
        (keydown.enter)="$event.preventDefault()"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          (opened)="onOpenSelect()"
          (optionSelected)="selected()"
          [autoActiveFirstOption]="false"
          [displayWith]="displayFn"
          >
          @if (
            matInputField.value?.length >= MIN_LENGTH_QUICK_SEARCH &&
            !filterAutocompleteLoaders &&
            filteredDataForAutocomplete?.length === 0) {
            <mat-option
              [value]="null"
              disabled
              >
              {{ "NO_OPTIONS_FOUND" | translate }}
            </mat-option>
          } @else {
            @for (
              option of filteredDataForAutocomplete; track trackByKeyName($index,
              option)) {
              <mat-option
                [value]="option"
                [innerHTML]="transformOption(option) | safeHtml"
                />
            }
          }

        </mat-autocomplete>

        <button mat-icon-button matSuffix [disableRipple]="true" type="button" [disabled]="!quickSearchForm.controls['searchControl']?.value">
          @if (
            (matInputField.value.length >= MIN_LENGTH_QUICK_SEARCH && filterAutocompleteLoaders) || isClearClicked) {
            <span
              class="loader"
            ></span>
          } @else {
            <mat-icon (click)="clearInput()"> close </mat-icon>
          }
        </button>
      </mat-form-field>
    </form>

    <button
      mat-icon-button
      type="button"
      class="quick-search-info-button"
      [attr.aria-label]="'ARIA_QUICK_SEARCH_INFO' | translate"
      [matTooltip]="'QUICK_SEARCH_TOOLTIP' | translate"
      matTooltipClass="quick-search-tooltip"
      matTooltipPosition="below"
      >
      <mat-icon>info</mat-icon>
    </button>
</div>